import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  action: false,
  open: false,
  message: 'Snackbar Message',
  anchorOrigin: {
    vertical: 'top',
    horizontal: 'right',
  },
  variant: 'default',
  alertSeverity: 'success',
  transition: 'Fade',
  close: true,
  actionButton: false,
};

export const snackbarSlice = createSlice({
  name: 'snackbar',
  initialState,
  reducers: {
    snackbarOpen(state, action) {
      const {
        open,
        message,
        anchorOrigin,
        variant,
        alertSeverity,
        transition,
        close,
        actionButton,
      } = action.payload;

      state.action = !state.action;
      state.open = open || initialState.open;
      state.message = message || initialState.message;
      state.anchorOrigin = anchorOrigin || initialState.anchorOrigin;
      state.variant = variant || initialState.variant;
      state.alertSeverity = alertSeverity || initialState.alertSeverity;
      state.transition = transition || initialState.transition;
      state.close = close === false ? close : initialState.close;
      state.actionButton = actionButton || initialState.actionButton;
    },
    openSnackbarSuccess(state, { payload: message }) {
      state.open = true;
      state.variant = 'alert';
      state.alertSeverity = 'success';
      state.message = message || initialState.message;
    },
    openSnackbarError(state, { payload: message }) {
      state.open = true;
      state.variant = 'alert';
      state.alertSeverity = 'error';
      state.message = message || initialState.message;
    },
    snackbarClose(state) {
      state.open = initialState.open;
    },
  },
});

export const {
  snackbarOpen,
  openSnackbarSuccess,
  openSnackbarError,
  snackbarClose,
} = snackbarSlice.actions;

export default snackbarSlice.reducer;
